module.exports = __webpack_public_path__ + "static/img/dy.da440cc7.png";